interface ProjectCardProps {
  project: {
    image: string
    alt: string
    title: string
    category: string
  }
  featured?: boolean
}

export function ProjectCard({ project, featured = false }: ProjectCardProps) {
  return (
    <figure className={`project-card${featured ? ' project-card--featured' : ''}`}>
      <img src={project.image} alt={project.alt} loading={featured ? 'eager' : 'lazy'} />
      <figcaption>
        <span>{project.category}</span>
        <strong>{project.title}</strong>
      </figcaption>
    </figure>
  )
}
